import './index.scss'
$("header .nav li").eq(1).addClass("active");
$(".nei-nav ul li").eq(4).addClass("active");